import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	messageBlastStatusName: {
		fontSize: "24px"
	},
	title: {
		fontSize: "25px",
		fontWeight: 700,
		textAlign: "center",
		lineHeight: "32px"
	},
	subtitle: {
		fontSize: "18px",
		fontWeight: 400,
		textAlign: "center"
	},
	whatsAppButton: {
		...ColorUtil.getBackgroundAndContrastColor(colors.green[600]),
		borderRadius: "8px",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.green[500])
		}
	},
	icon: {
		width: "40px",
		height: "40px"
	},
	textContainer: {
		padding: "14px"
	},
	container: {
		padding: "8px"
	},
	logo: {
		display: "block",
		margin: "0 auto",
		maxWidth: "120px",
		height: "auto"
	}
})

export default useStyles
